import React from "react";
import { Link } from "react-router-dom";

import styles from "./SectionsNav.module.scss";
import { useSectionsNav } from "./useSectionsNav";

export const SectionsNav: React.FC = () => {
  const { items } = useSectionsNav();

  return (
    <section className={styles.Section}>
      <nav className={styles.Nav}>
        {items.map((item) => (
          <Link key={item.path} to={item.path} className={styles.Chip}>
            <span className={styles.Count} aria-hidden="true">
              {item.count}
            </span>
            <span className={styles.Label}>{item.label}</span>
          </Link>
        ))}
      </nav>
    </section>
  );
};
